export const chaseItemDataTypes = [
    {
        id: "driversLicenseSummary",
        label: "Driver’s Licence Summary",
        desc: "DVLA generated summary if UK Licence, otherwise digital copy of front and back 📃",
    },
    {
        id: "licenseScan",
        label: "Driver’s Licence Digital Copy",
        desc: "Photo or scanned copy of the front & back of the customer’s driver’s licence 🪪",
    },
    {
        id: "disclosedClaims",
        label: "Previous Claims Proof",
        desc: "Determine whether the customer’s NCB matches Lexus Nexus’ records 📑",
    },
    {
        id: "ncbScan",
        label: "No Claims Bonus",
        desc: "Photo or scanned copy of the customer’s NCB from previous insurer 🛡️",
    },
    {
        id: "v5cScan",
        label: "V5C Digital Copy",
        desc: "Photo or scanned copy of the customer’s V5C document issued by the DVLA 📑",
    },
    {
        id: "bankStatement",
        label: "Bank Statement",
        desc: "Photo or scanned copy of the customer’s dated within the last 3 months 🗓️",
    },
    {
        id: "proofOfAddress",
        label: "Proof Of Address",
        desc: "A utility bill or bank statement letter showing dated within the last 3 months 🗓️",
    },
    {
        id: "odoMeterReading",
        label: "Odometer Reading",
        desc: "A picture of the vehicle’s dashboard clearing showing mileage on the odometer 🛣️",
    },
    {
        id: "mirroredNcbProof",
        label: "Mirrored No Claims Bonus Proof",
        desc: "Photo or scanned copy of the customer’s Mirroed NCB from previous insurer 🛡️",
    },
    {
        id: "photosOfVan",
        label: "Photos of Vehicle",
        desc: "Photos of the the vehicle’s interior and every side of exterior 🚐",
    },
];